import React from 'react';
import { twMerge } from 'tailwind-merge';
import StatusPill from './StatusPill';
import { ReactComponent as FileDraftIcon } from '@repo/common/assets/icons/20px/icon_20px_file-draft_outline.svg';
import { ReactComponent as GraphIcon } from '@repo/common/assets/icons/20px/icon_20px_graph-analytics_outline.svg';
import { ReactComponent as CheckCircleIcon } from '@repo/common/assets/icons/20px/icon_20px_check-circle_outline.svg';
import { ReactComponent as ProfileIcon } from '@repo/common/assets/icons/20px/icon_20px_profile_outline.svg';
import { ReactComponent as ShieldIcon } from '@repo/common/assets/icons/20px/icon_20px_shield-security-basic_outline.svg';

const ICON_MAP = {
  file: FileDraftIcon,
  id: ProfileIcon,
  home: ShieldIcon,
  graph: GraphIcon,
};

function EvidenceUploadCard({
  title,
  status = 'required',
  state = 'default',
  icon = 'file',
  fileName,
  linkUrl,
  linkCount = 0,
  actionLabel = 'Update',
  onAction,
  className,
}) {
  const isUploaded = state === 'uploaded';
  const Icon = ICON_MAP[icon] || FileDraftIcon;
  const description = isUploaded
    ? fileName ||
      linkUrl ||
      `${linkCount} link${linkCount > 1 ? 's' : ''} added`
    : 'Not uploaded yet';

  return (
    <article
      className={twMerge(
        'flex min-h-[72.5px] w-full items-center gap-6 rounded-[15px] border-[1.6px] border-grayscale-gray02 bg-grayscale-gray00 p-[17.6px]',
        'cursor-pointer transition-shadow duration-150 hover:shadow-3',
        state === 'hover' && 'shadow-3',
        className,
      )}
      onClick={onAction}
    >
      <div className='flex items-center flex-1 min-w-0 gap-3'>
        <span className='flex items-center justify-center rounded-lg size-10 shrink-0 bg-grayscale-gray01 text-icon-placeholder'>
          <Icon className='size-5' />
        </span>

        <div className='flex min-w-0 flex-1 flex-col gap-0.5'>
          <div className='flex items-center min-w-0 gap-2'>
            <h3 className='truncate typo-b14Strong text-text-primary'>
              {title}
            </h3>
            <StatusPill status={status} />
            {isUploaded && (
              <CheckCircleIcon className='size-5 shrink-0 text-icon-success' />
            )}
          </div>

          <div className='min-w-0 typo-b12 text-text-placeholder'>
            <p className='truncate'>{description}</p>
            {isUploaded && linkUrl && fileName && (
              <p className='truncate'>{linkUrl}</p>
            )}
          </div>
        </div>
      </div>

      <button
        type='button'
        className='shrink-0 rounded-lg bg-grayscale-gray01 px-3 py-1.5 typo-b13Strong text-grayscale-gray07 transition-colors hover:bg-grayscale-gray02 active:scale-[0.97]'
        onClick={(event) => {
          event.stopPropagation();
          onAction?.();
        }}
      >
        {actionLabel}
      </button>
    </article>
  );
}

export default EvidenceUploadCard;
